// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"8462d1c9","842":"642c7fe9"}[chunkId] + ".chunk.js";
};